import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
  firstName: "",
  lastName: "",
  phone: "",
  countryCode: "+1",
  countryFlag: "flags/USA",
  alpha3Code: "USA",
  email: "",
  gender: "",
  country: "",
  province: "",
  city: "",
  contest: "",
  category: "",
  contestIndex: "",
  aboutYourself: "",
  tillWhen: new Date(),
  profileImage: "",
  imageURL: "",
  enrolledContests: [],
  userId: "",
  notForMe: false,
  contestsList: [],
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.ENROLL_CONTEST_FILL_USER_DATA:
      let userData = action.payload;
      return {
        ...state,
        firstName: "",
        lastName: "",
        phone: userData.phone,
        email: userData.email,
        gender: userData.gender.charAt(0).toUpperCase() + userData.gender.slice(1),
        country: userData.locationInfo.country,
        countryName: userData.locationInfo.countryName,
        province: userData.locationInfo.state,
        city: userData.locationInfo.city,
        profileImage: "",
        imageURL: "",
        userId: userData._id,
        notForMe: false,
        countryCode: userData.countryCode,
        countryFlag: userData.locationInfo.countryFlag,
      }
    case actions.ENROLL_CONTEST_FIRST_NAME_CHANGED:
      return {
        ...state,
        firstName: action.payload
      };

    case actions.ENROLL_CONTEST_LAST_NAME_CHANGED:
      return {
        ...state,
        lastName: action.payload
      };

    case actions.ENROLL_CONTEST_PHONE_CHANGED:
      return {
        ...state,
        phone: action.payload
      };

    case actions.ENROLL_CONTEST_COUNTRY_CODE_CHANGED:
      return {
        ...state,
        countryCode: action.payload.code,
        countryFlag: action.payload.countryFlag,
        alpha3Code: action.payload.alpha3Code,
      };

    case actions.ENROLL_CONTEST_EMAIL_CHANGED:
      return {
        ...state,
        email: action.payload
      };

    case actions.ENROLL_CONTEST_COUNTRY_CHANGED:
      return {
        ...state,
        country: action.payload,
      };

    case actions.ENROLL_CONTEST_PROVINCE_CHANGED:
      return {
        ...state,
        province: action.payload
      };

    case actions.ENROLL_CONTEST_GENDER_CHANGED:
      return {
        ...state,
        gender: action.payload
      };

    case actions.ENROLL_CONTEST_CITY_CHANGED:
      return {
        ...state,
        city: action.payload
      };

    case actions.ENROLL_CONTEST_ABOUT_YOURSELF_CHANGED:
      return {
        ...state,
        aboutYourself: action.payload
      };

    case actions.ENROLL_CONTEST_CONTEST_CHANGED:
      let contest = state.contestsList[action.payload];
      return {
        ...state,
        contest: contest.name,
        category: contest.category,
        contestIndex: action.payload,
      };

    case actions.ENROLL_CONTEST_TILL_WHEN_CHANGED:
      return {
        ...state,
        tillWhen: action.payload
      };

    case actions.ENROLL_CONTEST_PROFILE_IMAGE_CHANGED:
      return {
        ...state,
        profileImage: action.payload.profileImage,
        imageURL: action.payload.imageURL,
      };

    case actions.ENROLL_CONTEST_GET_ENROLLED_CONTESTS:
      return {
        firstName: "",
        lastName: "",
        phone: "",
        countryCode: "",
        countryFlag: "",
        email: "",
        gender: "",
        country: "",
        province: "",
        city: "",
        contest: "",
        category: "",
        contestIndex: "",
        aboutYourself: "",
        tillWhen: new Date(),
        profileImage: "",
        imageURL: "",
        enrolledContests: [],
        userId: "",
        notForMe: false,
        contestsList: state.contestsList,
      }

    case actions.ENROLL_CONTEST_GET_ENROLLED_CONTESTS_SUCCESS:
      return {
        ...state,
        enrolledContests: action.payload
      };
    case actions.ENROLL_CONTEST_NOT_FOR_ME:
      return {
        ...state,
        notForMe: action.payload,
      }
    case actions.GET_CONTEST_LIST_SUCCESS:
      return {
        ...state,
        contestsList: action.payload,
      }
    case actions.ENROLL_CONTEST_REQUEST_SUCCESS:
      return {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        gender: "",
        country: "",
        province: "",
        city: "",
        contest: "",
        category: "",
        contestIndex: "",
        aboutYourself: "",
        tillWhen: new Date(),
        profileImage: "",
        imageURL: "",
        enrolledContests: [],
        userId: "",
        notForMe: false,
        contestsList: [],
      }
    default:
      return state;
  }
};
